module.exports = __webpack_public_path__ + "media/src/images/cancelBtn-880f7bac1c2fd45abc53304a78743b75.png";